import { get as _get } from 'lodash';

export default (physician) => (
  _get(physician, 'healthcareSites[0].name') &&
  _get(physician, 'healthcareSites[0].location.street1') &&
  _get(physician, 'healthcareSites[0].location.city') &&
  _get(physician, 'healthcareSites[0].location.state') &&
  _get(physician, 'healthcareSites[0].location.zip')
);
